var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "v-checkbox",
      class: {
        "v-checkbox--is-dirty": _vm.isDirty,
        "v-checkbox--is-disabled": _vm.disabled,
        "v-checkbox--has-label":
          Object.keys(_vm.options).length || this.$slots.default
      },
      attrs: { "data-vv-value-path": "model", "data-vv-as": _vm.label }
    },
    [
      _vm.selectAllCheckboxes
        ? _c(
            "label",
            { staticClass: "v-checkbox__item v-checkbox__item--select-all" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.allSelected,
                    expression: "allSelected"
                  }
                ],
                attrs: { type: "checkbox", name: "tags[]" },
                domProps: {
                  checked: Array.isArray(_vm.allSelected)
                    ? _vm._i(_vm.allSelected, null) > -1
                    : _vm.allSelected
                },
                on: {
                  change: [
                    function($event) {
                      var $$a = _vm.allSelected,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.allSelected = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.allSelected = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.allSelected = $$c
                      }
                    },
                    _vm.selectAll
                  ]
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "v-checkbox__indicator" }),
              _vm._v(" "),
              _c("span", [_vm._v("Select all")])
            ]
          )
        : _vm.customLabel && _vm.customLabel != ""
        ? _c("div", { staticStyle: { width: "100%" } }, [
            _c(
              "label",
              {
                staticClass: "v-form__label",
                staticStyle: { "margin-right": "10px" }
              },
              [_vm._v("\n      " + _vm._s(_vm.customLabel) + "\n    ")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      Object.keys(_vm.options).length
        ? _vm._l(_vm.options, function(option, key) {
            return _c(
              "label",
              { key: key, staticClass: "v-checkbox__item" },
              [
                _vm.isSingleCheckbox
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model,
                          expression: "model"
                        }
                      ],
                      attrs: {
                        type: "checkbox",
                        "true-value": 1,
                        "false-value": 0,
                        name: _vm.name,
                        disabled: _vm.disabled
                      },
                      domProps: {
                        value: key,
                        checked: Array.isArray(_vm.model)
                          ? _vm._i(_vm.model, key) > -1
                          : _vm._q(_vm.model, 1)
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a = _vm.model,
                              $$el = $event.target,
                              $$c = $$el.checked ? 1 : 0
                            if (Array.isArray($$a)) {
                              var $$v = key,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.model = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.model = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.model = $$c
                            }
                          },
                          function($event) {
                            return _vm.stateChange(_vm.model)
                          }
                        ]
                      }
                    })
                  : _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model,
                          expression: "model"
                        }
                      ],
                      attrs: {
                        type: "checkbox",
                        name: _vm.name,
                        id: _vm.id || _vm.name + "-" + key,
                        "data-id": _vm.customName + "-" + key,
                        disabled: _vm.disabled,
                        "true-value": "yes",
                        "false-value": "no"
                      },
                      domProps: {
                        value: key,
                        checked: Array.isArray(_vm.model)
                          ? _vm._i(_vm.model, key) > -1
                          : _vm._q(_vm.model, "yes")
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a = _vm.model,
                              $$el = $event.target,
                              $$c = $$el.checked ? "yes" : "no"
                            if (Array.isArray($$a)) {
                              var $$v = key,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.model = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.model = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.model = $$c
                            }
                          },
                          function($event) {
                            _vm.stateChange(_vm.model)
                            _vm.select()
                          }
                        ]
                      }
                    }),
                _vm._v(" "),
                _c("div", { staticClass: "v-checkbox__indicator" }),
                _vm._v(" "),
                option
                  ? [_c("span", { domProps: { innerHTML: _vm._s(option) } })]
                  : _vm._e()
              ],
              2
            )
          })
        : _c(
            "label",
            { staticClass: "v-checkbox__item" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.model,
                    expression: "model"
                  }
                ],
                attrs: {
                  type: "checkbox",
                  name: _vm.name,
                  disabled: _vm.disabled
                },
                domProps: {
                  checked: Array.isArray(_vm.model)
                    ? _vm._i(_vm.model, null) > -1
                    : _vm.model
                },
                on: {
                  change: [
                    function($event) {
                      var $$a = _vm.model,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.model = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.model = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.model = $$c
                      }
                    },
                    function($event) {
                      return _vm.stateChange(_vm.model)
                    }
                  ]
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "v-checkbox__indicator" }),
              _vm._v(" "),
              [_vm._t("default")]
            ],
            2
          ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.model,
            expression: "model"
          },
          {
            name: "validate",
            rawName: "v-validate",
            value: _vm.rules,
            expression: "rules"
          }
        ],
        attrs: { type: "hidden", name: "hidden_" + _vm.name },
        domProps: { value: _vm.model },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.model = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _vm.errors.has(_vm.newName)
        ? _c("div", { staticClass: "v-input__error" }, [
            _vm._v("\n    " + _vm._s(_vm.errors.first(_vm.newName)) + "\n  ")
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-673bd328", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-673bd328","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/admin/components/VCheckboxes.vue
// module id = 275
// module chunks = 1 2